export default __webpack_public_path__ + "static/media/blog.f942a01a.jpg";